import lozad from "lozad"
import { videoSourceInit } from "../../utils/videoSourceInit.util"

//  TODO er worden momenteel veel calls gemaakt in youtube later stadium bekijken
export const autoPlay = (): void => {
  const video = document.getElementById("backgroundVideo") as HTMLIFrameElement
  const thumbnail = document.querySelector("#thumbnail") as HTMLPictureElement

  if (video) {
    const playPauseButton = document.getElementById("playPauseButton")
    const observer = lozad(".lozad", {
      loaded: function () {
        if (thumbnail) {
          setTimeout(() => {
            thumbnail.classList.add("lg:hidden")
          }, 300)
        }
      },
    })
    observer.observe()
    observer.triggerLoad(video)

    if (video.getAttribute("data-initialized") === "true") return

    video.setAttribute("data-initialized", "true") // Set initialized flag so it runs only once

    videoSourceInit(video)

    // Attempt to play the video manually if autoplay fails
    video.addEventListener("load", () => {
      const videoWindow = video.contentWindow
      if (videoWindow) {
        playPauseButton?.classList.remove("play", "hidden")
        playPauseButton?.classList.add("pause")

        if (video.src.includes("vimeo.com")) {
          videoWindow.postMessage('{"method":"play"}', "https://vimeo.com")
        } else if (video.src.includes("youtube")) {
          videoWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "https://youtube.com")
        }
      }
    })
  }
}
